import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { yupResolver } from "@hookform/resolvers/yup";
import logo from "assets/images/logo_login.png";
import profile from "assets/images/profile-img.png";
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { loginRequest } from "../../auth/authConfig";
import { genJwtFromAzure, loginUser, socialLogin } from "../../store/actions";
import "./index.scss";
// import ReCAPTCHA from "react-google-recaptcha";
// import { env } from "configs/EnvironmentConfig";

const Login = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["common"]);
  const { instance } = useMsal();
  const pathUrl = window.location.pathname || "";

  const {
    error,
    azure,
    loading: loadingLogin,
  } = useSelector(state => state.Login);

  const [isShowForm, setIsShowForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [tokenReCaptcha, setTokenReCaptcha] = useState(null);

  const schema = yup.object().shape({
    email: yup
      .string()
      .required(t("validate.required", { title: t("login.email") }))
      .email(t("validate.invalid", { title: t("login.email") }))
      .max(100, t("validate.char_max", { max: 100 })),
    password: yup
      .string()
      .required(t("validate.required", { title: t("login.password") }))
      .max(40, t("validate.char_max", { max: 40 })),
    remember_me: yup.bool(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      email: "",
      password: "",
      remember_me: false,
    },
  });

  // useEffect(() => {
  //   console.log("instance", instance);
  // }, []);

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(loginUser(values, navigate));
  };

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.history, type));
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.history, type));
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = response => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = response => {
    signIn(response, "facebook");
  };

  const popupWindow = (url, windowName, win, w, h) => {
    const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
    const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
    return win.open(
      url,
      windowName,
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
  };

  const handleLoginSSO = instance => {
    if (azure.error) {
      instance.logoutPopup({
        postLogoutRedirectUri: "/login",
        mainWindowRedirectUri: "/login",
      });
    } else {
      instance.loginPopup(loginRequest).catch(e => {
        console.log("errorHandleLoginSSO", e);
      });
    }
  };

  // const onChangeReCaptcha = value => {
  //   setTokenReCaptcha(value);
  // };

  const handleLogin = e => {
    e.preventDefault();
    trigger().then(isValidateSuccess => {
      if (isValidateSuccess) {
        const data = getValues();
        dispatch(loginUser(data, navigate));
      }
    });
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>{t("login.login")} | G-Logistic</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("login.welcome")}</h5>
                        <p style={{ marginBottom: 0 }}>
                          {t("login.header_form_login")}
                        </p>
                        <p>{"Gene Solutions"}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div className="row row-cols-1 justify-content-end">
                    <div className="col-auto p-0">
                      <div className="navbar-header p-0 Login__Language">
                        <LanguageDropdown />
                      </div>
                    </div>
                  </div>
                  <div className="p-2">
                    {isShowForm && (
                      <React.Fragment>
                        <img
                          className="mb-5"
                          alt="logo"
                          src={logo}
                          width={"100%"}
                        ></img>
                        <Form onSubmit={handleLogin}>
                          {error ? (
                            <Alert
                              color="danger"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                              }}
                            >
                              <i className="fas fa-exclamation-circle fa-2x"></i>
                              {t("login.submit.error")}
                            </Alert>
                          ) : null}
                          <div className="mb-3">
                            <label htmlFor="email">Email</label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "email"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("login.email"),
                              })}
                              {...register("email")}
                            />
                            {errors.email && (
                              <MessageFormValidate
                                error={errors.email.message}
                              />
                            )}
                          </div>
                          <div className="mb-3">
                            <label htmlFor="password">
                              {t("login.password")}
                            </label>
                            <div className="input-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className={`form-control ${formValidate(
                                  errors,
                                  touchedFields,
                                  "password"
                                )}`}
                                placeholder={t("placeholder.enter", {
                                  title: t("login.password"),
                                })}
                                {...register("password")}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-info"
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                              >
                                {showPassword ? (
                                  <i className="fas fa-eye-slash"></i>
                                ) : (
                                  <i className="fas fa-eye"></i>
                                )}
                              </button>
                            </div>
                            {errors.password && (
                              <MessageFormValidate
                                error={errors.password.message}
                              />
                            )}
                          </div>
                          <div className="form-check form-check-inline mb-3">
                            <Label check>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                {...register("remember_me")}
                              />{" "}
                              {t("login.remember_me")}
                            </Label>
                          </div>
                          {/* <div>
                          <ReCAPTCHA
                            sitekey={env.CAPTCHA_SITE_KEY || ""}
                            hl={i18n.language === "vn" ? "vi" : "en"}
                            onChange={onChangeReCaptcha}
                          />
                        </div> */}

                          <div className="mt-3 d-grid">
                            <button
                              type="submit"
                              disabled={
                                // azure.loading || loadingLogin || !tokenReCaptcha
                                azure.loading || loadingLogin
                              }
                              className="btn btn-primary btn-block"
                              onClick={handleLogin}
                            >
                              {t("login.login")}
                            </button>
                          </div>
                        </Form>
                      </React.Fragment>
                    )}
                    {isShowForm && (
                      <div className="text-muted mb-3 mt-2 font-size-14 font-weight-bold text-center">
                        <div
                          style={{
                            width: "100%",
                            height: "11px",
                            borderBottom: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <span
                            style={{
                              backgroundColor: "white",
                              padding: "0 10px",
                            }}
                          >
                            <strong>{t("login.or")}</strong>
                          </span>
                        </div>
                      </div>
                    )}
                    {!isShowForm && (
                      <React.Fragment>
                        {/* <h2
                          className="text-center mb-5"
                          style={{ color: "#00ACB5", fontWeight: 600 }}
                        >
                          {String(
                            t("login.system", { title: "G-Logistic" })
                          ).toUpperCase()}
                        </h2> */}
                        <img className="mb-5" src={logo} width={"100%"}></img>
                      </React.Fragment>
                    )}

                    {azure.error && (
                      <Alert
                        color="danger"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                        }}
                      >
                        <i className="bx bx-error-circle font-19" />
                        {azure.error}
                      </Alert>
                    )}
                    <div className="mt-2 d-grid">
                      <button
                        disabled={azure.loading || loadingLogin}
                        className="btn btn-success btn-block"
                        onClick={() => handleLoginSSO(instance)}
                        style={{ backgroundColor: "#00ACB5" }}
                      >
                        {t("login.btn_employee_login_label")}
                      </button>
                    </div>
                    {!isShowForm && (
                      <React.Fragment>
                        <div className="mt-3 text-center">
                          {/* <p>
                            <span
                              className="fw-medium text-primary"
                              onClick={() => {
                                if (pathUrl && pathUrl === "/login-dev") {
                                  setIsShowForm(true);
                                }
                              }}
                            >
                              {t("login.use_email_account")}
                            </span>
                          </p> */}
                          <p className="d-flex align-items-center justify-content-center">
                            {t("login.is_have_account")}{" "}
                            <Button
                              color="link"
                              className="fw-medium text-primary"
                              onClick={() => {
                                setIsShowForm(true);
                              }}
                            >
                              {t("login.login")}
                            </Button>
                          </p>
                        </div>
                      </React.Fragment>
                    )}
                    {/* <div
                      className="text-center"
                      style={{
                        color: "gray",
                        fontWeight: "bold",
                      }}
                    >
                      Or
                    </div> */}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-1 text-center">
                <p>©Copyright LCS</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <AuthenticatedTemplate>
        <GenAppJWTFromSSOToken
          dispatch={dispatch}
          navigate={navigate}
          loading={azure.loading}
        />
      </AuthenticatedTemplate>
    </React.Fragment>
  );
};

const GenAppJWTFromSSOToken = props => {
  const { dispatch, navigate, loading } = props;
  const { instance, accounts } = useMsal();

  useEffect(() => {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then(response => {
        localStorage.clear();
        dispatch(
          genJwtFromAzure(response.accessToken, response.idToken, navigate)
        );
      });
  }, []);

  return (
    <React.Fragment>
      {loading && (
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
              <div className="chase-dot" />
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Login;

Login.propTypes = {
  history: PropTypes.object,
};

GenAppJWTFromSSOToken.propTypes = {
  navigate: PropTypes.any,
  dispatch: PropTypes.any,
  loading: PropTypes.any,
};
